import { useState, useRef, useEffect, forwardRef, useImperativeHandle, cloneElement } from 'react';
import { GridRow, DataGrid as MuiDataGrid, gridFilteredSortedRowIdsSelector, gridVisibleColumnFieldsSelector, ptBR } from '@mui/x-data-grid';
import { Box, Grid, MenuItem, IconButton, useMediaQuery, Drawer, Fab, TablePagination } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { clearEmptyFields } from 'utils/utils';
import Loading from 'components/Loaging';
import Error from 'components/Error';
import Pagination from 'components/Pagination';
import Select from 'components/Select';
import style from './style';
// import Breadcrumbs from 'components/Breadcrumbs';
import PageTittle from 'components/PageTittle';
import Typography from 'components/Typography';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import { AddRounded, PriorityHighRounded, SaveAltRounded, HelpOutline, SearchRounded, Close } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useNavigate, useMatches } from 'react-router';
import { getPermissions } from 'utils/userUtils';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import xlsx from 'json-as-xlsx';
import theme from 'theme';
import ListingCards from 'components/ListingCards';

const DataGrid = forwardRef(({ subtitle, ...props }, ref) => {
  const { t } = useTranslation('Actions');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [orderBy, setOrderBy] = useState();
  const [filters, setFilters] = useState();
  const [formatedFilters, setFormatedFilters] = useState();
  const [mobileFilterDrawer, setMobileFilterDrawer] = useState(false);
  const navigate = useNavigate();

  const apiRef = useRef();
  const matches = useMatches();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const debounceTimers = useRef({});

  const form = useForm({ defaultValues: { ...(props.enableDisableItem && { SITUACAO: '%%' }), ...filters } });
  const { getValues, control, reset } = form;

  const routePermission = matches
    .find((match) => Boolean(match.handle?.permission))
    ?.handle?.permission;

  const situationColumn = [{
    headerName: t('Situação'),
    field: 'SITUACAO',
    sortable: false,
    width: 120,
    filter: <Select defaultValue={filters?.SITUACAO ?? '%%'}
      //displayEmpty={true}
      options={[
        { label: <Typography color={'#bfbfbf'}>{'Todos'}</Typography>, value: '%%' },
        { label: 'Ativos', value: '1' },
        { label: 'Inativos', value: '0' }
      ]}
    />,
    renderCell: (data) => data.value === 1 ? 'Ativo' : 'Inativo'
  }];

  let columns = props.columns;
  if (props.enableDisableItem) {
    const beforeInsert = columns.slice(0, columns.length - 1);
    const afterInsert = columns.slice(columns.length - 1);
    columns = [...beforeInsert, ...situationColumn, ...afterInsert];
  };

  columns[columns.length - 1] = {
    ...columns[columns.length - 1],
    filter:
      <Button fullWidth onClick={() => handleClearFilter()}>
        Limpar
      </Button>
  }

  const tableProps = {
    setError,
    setLoading,
    ...orderBy && { orderBy },
    ...filters && { filters: formatedFilters },
    query: {
      limit: pageSize,
      page: page
    }
  };

  const handleClearFilter = () => {
    setFormatedFilters({});
    setFilters({});

    //PASS EMPTY ARRAY TO ALL FILTER FIELDS
    var mapped = columns.map(item => ({ [item.field]: '' }));
    reset({ ...Object.assign({}, ...mapped), SITUACAO: '%%' });
  };

  const refresh = () => {
    setLoading(true);
    props.getData(tableProps).then(response => {
      setRows(response.data);
      setCount(response.count);
      setLoading(false);
    });
  };

  const handlePageChange = (_e, value) => {
    setPage(value);
  };

  const handleSizeChange = (e) => {
    setPage(1);
    setPageSize(e.target.value);
  };

  const handleSortChange = (e) => {
    const sortModel = e[0];

    if (Boolean(sortModel))
      setOrderBy([sortModel.field, sortModel.sort]);
    else
      setOrderBy(null);
  };

  const handleFilterChange = (fieldName) => {
    const columnDef = columns.find(column => column.field === fieldName);
    const debounceTime = columnDef?.debounceTime ?? 1500;

    clearTimeout(debounceTimers.current[fieldName]);

    const applyFilters = () => {
      let filters = clearEmptyFields(getValues());

      let formatedFilters = Object.entries(filters)
        .map(([key, value]) => {
          let filterOptions = columns.find(column => column.field === key);

          if (typeof filterOptions?.filterGetter === 'function') {
            value = filterOptions.filterGetter(value);
          };

          if (typeof filterOptions?.filterQuery === 'function')
            return filterOptions.filterQuery(value);
          else
            return ({ [key]: { 'substring': [value] } });
        });

      formatedFilters = {
        condicaoWhere: {
          and: formatedFilters
        }
      };

      setFormatedFilters(formatedFilters);
      setPage(1);
      setFilters(filters);
    };

    if (debounceTime === 0) {
      applyFilters();
    } else {
      debounceTimers.current[fieldName] = setTimeout(applyFilters, debounceTime);
    }
  };

  let teste = {};
  columns.forEach((el) => teste[el.field] = "");

  const FilterRow = (props) => {
    return (
      <GridRow {...props} />
    );
  };

  const CustomRow = forwardRef((props, ref) => {
    let renderedColumns = props.renderedColumns.map(column => ({
      ...column,
      renderCell: () =>
        column.filter
          ?
          <Controller
            name={column.field}
            control={control}
            render={({ field: { ref, ...field } }) => (
              cloneElement(column.filter, {
                ...field,
                inputRef: ref,
                onKeyDown: (e) => e.stopPropagation(),
                onChange: (e) => {
                  field.onChange(e);
                  handleFilterChange(column.field);
                },
                placeholder: 'Buscar',
                id: column.field,
                name: column.field
              })
            )}
          />
          :
          undefined
    }));

    let visibleColumns = props.visibleColumns.map(column => ({
      ...column,
      renderCell: () =>
        column.filter
          ?
          <Controller
            name={column.field}
            control={control}
            render={({ field: { ref, ...field } }) => (
              cloneElement(column.filter, {
                onKeyDown: (e) => e.stopPropagation(),
                onChange: (e) => {
                  field.onChange(e);
                  handleFilterChange(column.field);
                },
                placeholder: 'Buscar',
                id: column.field,
                name: column.field
              })
            )}
          />
          :
          undefined
    }));

    let rowProps = { ...props, renderedColumns, visibleColumns }

    return (
      props.index === 0
        ? <FilterRow ref={ref} {...rowProps} />
        : <GridRow ref={ref} {...props} />
    )
  });

  useEffect(() => {
    refresh();
  }, [props.getData, pageSize, page, orderBy, filters]);

  useImperativeHandle(ref, () => ({
    refresh,
    printPDF
  }));

  const exportXLSX = () => {
    const visibleColumnsField = gridVisibleColumnFieldsSelector(apiRef);
    let tableData = getJson(apiRef);

    let nameColumns = []
    columns.forEach((column) => {
      if (column.field !== 'GUID' && column.field !== 'SITUACAO')
        if (visibleColumnsField.includes(column.field))
          nameColumns.push({ label: column.headerName, value: column.field.replaceAll('$', '').replaceAll('.', '') });
    });

    let data = [
      {
        sheet: "Table",
        columns: nameColumns,
        content: tableData,
      }
    ]

    let settings = {
      fileName: "table",
      extraLength: 3,
      writeMode: "writeFile",
      writeOptions: {}
    }

    xlsx(data, settings);
  };

  const printPDF = () => {
    const doc = new jsPDF();

    doc.autoTable({
      html: '.table',
      tableWidth: 'wrap',
      styles: { cellPadding: 0.5, fontSize: 8, color: 'red' },
    })

    const visibleColumnsField = gridVisibleColumnFieldsSelector(apiRef);
    const tableData = getJson(apiRef);

    let nameColumns = []
    columns.forEach((column) => {
      if (column.field !== 'GUID' && column.field !== 'SITUACAO')
        if (visibleColumnsField.includes(column.field))
          nameColumns.push(column.headerName)
    });

    let tableItems = [];
    tableData.forEach((element) => {
      tableItems.push(Object.values(element));
    });

    autoTable(doc, {
      head: [nameColumns],
      body: tableItems,
      margin: [10, 10],
      styles: { cellPadding: 0.5, fontSize: 8, color: 'red' },
      headStyles: {
        fillColor: [0, 128, 128],
      },
    });

    doc.save('table.pdf');
  };

  const getJson = (apiRef) => {

    // Select rows and columns
    const filteredSortedRowIds = gridFilteredSortedRowIdsSelector(apiRef);
    const visibleColumnsField = gridVisibleColumnFieldsSelector(apiRef);

    // Format the data. Here we only keep the value
    const data = filteredSortedRowIds.map((id) => {
      const row = {};
      visibleColumnsField.forEach((field) => {
        if (field !== 'GUID' && field !== 'SITUACAO')
          row[field.replaceAll('$', '').replaceAll('.', '')] = apiRef.current.getCellParams(id, field).value;
      });
      return row;
    });

    data.shift();

    return data;
  };

  return (
    <>
      <Loading open={(loading && !error)} />
      <Grid container>
        {/* <Grid item xs={6}>
          <Breadcrumbs/>
        </Grid> */}
        <Grid container>
          <Grid item container xs={12} md={6} py={2} alignItems='center'>
            <PageTittle />
            {(props.helpURL && typeof props.helpURL !== 'object') &&
              <IconButton onClick={() => window.open(props.helpURL, '_blank').focus()} sx={{ marginX: 1 }}>
                <HelpOutline />
              </IconButton>
            }
            {(props.helpURL && typeof props.helpURL === 'object') &&
              <Dropdown
                anchor={
                  <IconButton sx={{ marginX: 1 }}>
                    <HelpOutline />
                  </IconButton>
                }
              >
                {props.helpURL.map((el, i) =>
                  <MenuItem key={i} onClick={() => window.open(el.url, '_blank').focus()}>
                    {t(el.label)}
                  </MenuItem>
                )}
              </Dropdown>
            }
            {props.titleExtra &&
              props.titleExtra
            }
            {/* <Typography variant='subtitle1' color='secondary'>
              {typeof subtitle === 'function' ? subtitle(count) : subtitle}
            </Typography> */}
          </Grid>
          {!isMobile &&
            <Grid container item spacing={1} xs={12} md={6}>
              <Grid container item spacing={1} justifyContent='flex-end' alignItems='center'>
                {props.extra &&
                  <Grid item>
                    {props.extra}
                  </Grid>
                }
                <Grid item>
                  <Dropdown
                    anchor={<Button variant='outlined' startIcon={<SaveAltRounded />}>{t('Exportar')}</Button>}
                  >
                    <MenuItem onClick={exportXLSX}>
                      {t('Exportar em XLSX')}
                    </MenuItem>
                    <MenuItem onClick={printPDF}>
                      {t('Exportar em PDF')}
                    </MenuItem>
                  </Dropdown>
                </Grid>
                {(props.addNew && getPermissions(routePermission).include) &&
                  <Grid item>
                    <Button
                      id='add_new'
                      startIcon={<AddRounded />}
                      variant='contained'
                      onClick={props.addNew.onClick}
                      fullWidth>
                      {props.addNew.title}
                    </Button>
                  </Grid>
                }
              </Grid>
              {/* <Grid container item spacing={1} justifyContent='flex-end'>
                <Grid item>
                  <Select
                    value={pageSize}
                    onChange={handleSizeChange}
                    options={[
                      { label: '10 / página', value: 10 },
                      { label: '15 / página', value: 15 },
                      { label: '20 / página', value: 20 }
                    ]}
                  />
                </Grid>
                <Grid item>
                  <Pagination
                    page={page}
                    count={Math.ceil(count / pageSize)}
                    onChange={handlePageChange}
                    boundaryCount={0}
                    siblingCount={1}
                    size='small'
                    variant='outlined'
                    shape='rounded'
                    showFirstButton
                    showLastButton
                  />
                </Grid>
              </Grid> */}
            </Grid>
          }
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item mb={8} xs={12}>
          {(!loading && !error) &&
            <>
              {!isMobile
                ?
                <MuiDataGrid
                  apiRef={apiRef}
                  sx={style}
                  rows={[{ key: '1', GUID: '1', ...teste }, ...rows]}
                  getRowId={(row) => row.GUID}
                  onSortModelChange={handleSortChange}
                  sortingMode='server'
                  rowSelection={false}
                  hideFooter={true}
                  density='standard'
                  columns={columns}
                  disableColumnFilter
                  slots={{
                    row: CustomRow
                  }}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                  }
                  localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                  initialState={{
                    sorting: {
                      ...orderBy && { sortModel: [{ field: orderBy[0], sort: orderBy[1] }] },
                    },
                  }}
                />
                :
                <ListingCards
                  cards={rows ?? []}
                  fields={columns}
                />
              }
            </>
          }
          {error &&
            <Error
              icon={<PriorityHighRounded fontSize='large' />}
              title={t('Não foi possível carregar os dados.')}
              subtitle={t('Ocorreu um erro durante a comunicação com o servidor.')}
              extra={
                <Button
                  variant='outlined'
                  onClick={() => { setError(false); refresh() }}>
                  {t('Tentar novamente')}
                </Button>
              }
            />
          }
        </Grid>
        {!isMobile &&
          <Box
            sx={{
              position: 'fixed',
              background: '#fff',
              height: '62px',
              borderTop: '2px solid #ff3d03',
              bottom: 0,
              left: 'var(--sidebar-width, 248px)',
              width: 'calc(100% - var(--sidebar-width, 248px))',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography
              variant='body2'
              sx={{
                color: '#343A40',
                fontFamily: "'Open Sans', sans-serif",
                fontSize: '12px',
                px: 1,
                '& b': { fontWeight: 600 },
              }}
            >
              Encontrados <b>{count} resultados</b> em <b>{Math.ceil(count / pageSize)} páginas</b>
            </Typography>
            <Select
              value={pageSize}
              onChange={handleSizeChange}
              fullWidth={false}
              sx={{ px: 1 }}
              inputProps={{
                sx: {
                  py: 0.57
                }
              }}
              options={[
                { label: '10', value: 10 },
                { label: '15', value: 15 },
                { label: '20', value: 20 }
              ]}
            />
            <Box sx={{ px: 1 }}>
              <Pagination
                page={page}
                count={Math.ceil(count / pageSize)}
                onChange={handlePageChange}
                boundaryCount={0}
                siblingCount={1}
                size='small'
                variant='outlined'
                shape='rounded'
                showFirstButton
                showLastButton
              />
            </Box>
          </Box>
        }
        {(isMobile) &&
          <>
            <Box
              sx={{
                position: 'fixed',
                bottom: 65,
                right: 90,
                '& > :not(style)': { m: 1 }
              }}
            >
              <Fab onClick={() => setMobileFilterDrawer(!mobileFilterDrawer)}>
                <SearchRounded />
              </Fab>
              <Fab onClick={() => navigate('novo')} color='primary'>
                <AddRounded />
              </Fab>
            </Box>

            <Box
              sx={{
                position: 'fixed',
                background: '#fff',
                height: '62px',
                borderTop: '2px solid #ff3d03',
                bottom: 0,
                left: 0,
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <TablePagination
                component={'div'}
                page={page - 1}
                count={count}
                rowsPerPage={pageSize}
                rowsPerPageOptions={[10, 15, 20]}
                labelRowsPerPage={'Por página'}
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                onPageChange={(_e, page) => handlePageChange(_e, page + 1)}
                onRowsPerPageChange={handleSizeChange}
              />
            </Box>

            <Drawer
              open={mobileFilterDrawer}
              anchor='right'
              onClose={() => setMobileFilterDrawer(false)}
            >
              <Box sx={{ width: 250, p: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant='h6' >Filtros</Typography>
                      <IconButton onClick={() => setMobileFilterDrawer(false)}><Close /></IconButton>
                    </Box>
                  </Grid>
                  {columns.map((el, i) => {
                    return (
                      <Grid key={i} item xs={12}>
                        <Controller
                          name={el.field}
                          control={control}
                          render={({ field: { ref, ...field } }) => (
                            cloneElement(el.filter, {
                              ...field,
                              value: field.value ?? '',
                              //inputRef: ref,
                              onKeyDown: (e) => e.stopPropagation(),
                              onChange: (e) => {
                                field.onChange(e);
                                handleFilterChange(el.field);
                              },
                              label: el.headerName,
                              id: el.field,
                              name: el.field
                            })
                          )}
                        />
                      </Grid>
                    )
                  })}
                </Grid>
              </Box>
            </Drawer>
          </>
        }
      </Grid>
    </>
  )
}); export default DataGrid;